import React, { Fragment } from 'react';
import ListaHeroes from './ListaHeroes';


const VistaMarvel = (props) => {

    return (
        <Fragment>
            <ListaHeroes editorial="Marvel Comics" />
        </Fragment>
    )
}
export default VistaMarvel;